import { User } from './../../shared/services/user';
import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";
declare var M: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(
    public authService: AuthService) {
    this.userProfile = this.authService.getUserProfile;
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    this.setUser();
    // setTimeout(function () { (<HTMLInputElement>document.getElementById("initDD")).click(); }, 1000);

  }
  userProfile: User;
  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    M.toast({ html: 'Copied to Clipboard!' })
  }
  confirm(s) {
    return confirm(s)
  }
  setUser() {
    this.userProfile = this.authService.getUserProfile;
    this.Admin = this.userProfile.admin;
    this.SalesStorage = this.userProfile.sales && this.userProfile.storage;
  }
  Admin = false;
  SalesStorage = false;
  admin() {
    this.Admin = !this.Admin;
  }
  ss() {
    this.SalesStorage = !this.SalesStorage;
  }
  ngOnInit() {
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
// 
    this.userProfile = this.authService.getUserProfile;
  //  console.log(this.userProfile);
    if (this.userProfile) {
      // (<HTMLInputElement>document.getElementById('progress')).className = "progress hide";  
    } else {
      // setTimeout(function () { window.location.reload(); }, 500);
      //window.location.reload();
    }
  }

}
